module.exports = __webpack_public_path__ + "files/146675a6801bdeb89a2ebf57700cdc5b.svg";